module.exports = __webpack_public_path__ + "img/38_7.794942fa.png";